module.exports = __webpack_public_path__ + "img/marna-logo-final.3dae2974.jpg";